import { FormKitNode } from '@formkit/core'

/**
 * Formats FormKit form submissions by auto-adding `form-id` and `user-id` prop
 * data and nesting form field data under a `data` key before submission.
 */
const standardFormDataPlugin = (node: FormKitNode) => {
  if (node.props.type !== 'form') {
    return
  }

  node.addProps([
    'formId',
    'userId',
  ])

  if (!node.props.formId) {
    throw new Error('FormKit Plugin Error (standardSubmissionFormat): Must pass a form-id prop to the form element')
  }

  node.hook.submit((payload, next) => {
    const finalPayload = {
      formId: node.props.formId,
      userId: node.props.userId || null,
      data: payload,
    }

    return next(finalPayload)
  })
}

export default standardFormDataPlugin
